/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayGameScoreDtoSchema } from "./goodLuck/core/DTOs/replayGameScoreDtoSchema.ts";
import { microsoftAspNetCoreMvcProblemDetailsSchema } from "./microsoft/aspNetCore/mvc/problemDetailsSchema.ts";
import { z } from "zod/v4";

export const getTournamentsTournamentidReplayMetricsGameScoresPathParamsSchema =
  z.object({
    tournamentId: z.string(),
  });

/**
 * @description OK
 */
export const getTournamentsTournamentidReplayMetricsGameScores200Schema =
  z.array(z.lazy(() => goodLuckCoreDTOsReplayGameScoreDtoSchema));

/**
 * @description Not Found
 */
export const getTournamentsTournamentidReplayMetricsGameScores404Schema =
  z.lazy(() => microsoftAspNetCoreMvcProblemDetailsSchema);

export const getTournamentsTournamentidReplayMetricsGameScoresQueryResponseSchema =
  getTournamentsTournamentidReplayMetricsGameScores200Schema;
